module.exports = __webpack_public_path__ + "static/media/close.95fc9d60.svg";